"use client";

import React from "react";

import Link from "@/components/Link";
import cx from "classnames";
import { useParams, usePathname } from "next/navigation";
import { useClickAway } from "react-use";

type Languages = { [key: string]: { label: string; emoji: string } };

const languages: Languages = {
  en: { label: "English", emoji: "🇬🇧" },
  ru: { label: "Russian", emoji: "🇷🇺" },
  de: { label: "German", emoji: "🇩🇪" },
};

const LanguageSelector = ({
  id = "top",
  dropDownDirection = "down",
  languageSpecificPaths,
  theme = "light",
}) => {
  const pathname = usePathname();
  const params = useParams();

  const ref = React.useRef(null);
  useClickAway(ref, () => {
    setLanguagesDropdown(false);
  });

  const [showLanguagesDropdown, setLanguagesDropdown] = React.useState(false);

  const switchPathnameLanguage = React.useCallback(
    (newLang) => {
      if (params.lang == "en") {
        if (languageSpecificPaths) {
          if (languageSpecificPaths[newLang]) {
            return `/${newLang}${languageSpecificPaths[newLang]}`;
          }

          return `/${newLang}`;
        }

        return `/${newLang}${pathname}`;
      }

      if (languageSpecificPaths) {
        if (languageSpecificPaths[newLang]) {
          return `/${newLang}${languageSpecificPaths[newLang]}`;
        }

        return `/${newLang}`;
      }

      return pathname.replace(`/${params.lang}`, `/${newLang}`);
    },
    [pathname, params, languageSpecificPaths],
  );

  console.log({ languages, lang: params.lang });

  return (
    <div className="language-selector inline-block relative" ref={ref}>
      <button
        className={cx("flex flex-nowrap gap-0.5 px-1 md:px-2 py-1 font-medium rounded-md ", {
          "hover:bg-neutral-100": theme !== "dark",
          "text-white hover:bg-neutral-900": theme === "dark",
        })}
        onClick={() => setLanguagesDropdown((prev) => !prev)}
      >
        <span className="whitespace-nowrap">
          <span className="text-sm">{languages[params.lang ?? "en"].emoji}</span>{" "}
          {languages[params.lang].label}
        </span>

        <span className="caret"></span>
      </button>

      {showLanguagesDropdown && (
        <div
          className={cx("absolute right-0", {
            "top-full": dropDownDirection === "down",
            "bottom-full": dropDownDirection === "up",
          })}
        >
          <div
            className={cx("px-3 py-3 rounded-sm shadow-md", {
              "bg-white": theme !== "dark",
              "bg-neutral-900 text-white": theme === "dark",
            })}
          >
            <ul className="text-sm">
              {Object.keys(languages)
                .filter((key) => key !== params.lang)
                .map((langKey) => (
                  <li key={`${id}-${langKey}`}>
                    {/* <Link */}
                    <a
                      href={switchPathnameLanguage(langKey)}
                      className={cx("block px-2 py-1 text-medium rounded-md whitespace-nowrap", {
                        "hover:bg-neutral-100": theme !== "dark",
                        "hover:bg-black": theme === "dark",
                      })}
                      // prefetch={false}
                    >
                      <span>{languages[langKey].emoji}</span> {languages[langKey].label}
                      {/* </Link> */}
                    </a>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
